module.exports = __webpack_public_path__ + "static/img/2.8cccb69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/2.png
// module id = +0/H
// module chunks = 12